export default function(string) {
  const lowerCase = string.toLocaleLowerCase().trim()
  const withoutAccents = global.helpers.unaccent(lowerCase)

  return withoutAccents
}
